import { createStandardAction } from 'typesafe-actions'
import { ExperimentState } from './reducer'

export const SET_EXPERIMENT_VARIANT = 'experiment/SET_EXPERIMENT_VARIANT'

export const setExperimentVariant = createStandardAction(SET_EXPERIMENT_VARIANT)<
  ExperimentState
>()



// WEBPACK FOOTER //
// ./src/state/experiment/actions.ts